import { z } from 'zod'

export const updateEmpresaSchema = z.object({
  nome: z.string().min(3).max(200).optional(),
  endereco: z.string().min(5).max(300).optional(),
  cidade: z.string().min(2).max(100).optional(),
  telefone: z.string().optional(),
  email: z.string().email().optional(),
})

export type UpdateEmpresaInput = z.infer<typeof updateEmpresaSchema>
